<template>
    <Accordion >
        <AccordionPanel  value="0">
            <AccordionHeader><span class="font-semibold text-lg underline">Payment Details</span></AccordionHeader>
            <AccordionContent style="background: rgb(255 255 255);">
                <div class="grid grid-cols-12 gap-6 mt-5">
                    <div class="col-span-12 md:col-span-6 xl:col-span-3 ">
                        <Card class="card-bg">
                            <template #content>
                                <div class="w-full">
                                    <div id="name-section" class="w-full">
                                        <!-- Bank Name -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">VAT number:</span>
                                            <div class="flex justify-center items-center ">
                                                <span v-if="isVatProvided">{{ user.vat }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Card>
                    </div>

                    <div class="col-span-12 md:col-span-12 xl:col-span-8">
                        <Card class="card-bg">
                            <template #content>
                                <div class="w-full">
                                    <div id="bank-section" class="w-full md:grid md:grid-cols-3 pt-1 gap-4"
                                        style="grid-template-columns: 49% 23% 25%;">
                                        <!-- Street Name -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">Street Name:</span>
                                            <div class="w-full">
                                                <span v-if="isAddressProvided">{{ user.address.street }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>  
                                        </div>

                                        <!-- City -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">City:</span>
                                            <div>
                                                <span v-if="isAddressProvided">{{ user.address.city }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>

                                        <!-- Country -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">Country:</span>
                                            <div>
                                                <span v-if="isAddressProvided">{{ user.address.country }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Card>
                    </div>

                    <div class="col-span-12 md:col-span-12 xl:col-span-12">
                        <Card class="card-bg">
                            <template #content>
                                <div class="w-full">
                                    <div id="bank-section" class="w-full md:grid md:grid-cols-3 pt-1 gap-4"
                                        style="grid-template-columns: 25% 23% 49%;">
                                        <!-- Bank Name -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">Bank Name:</span>
                                            <div class="w-full">
                                                <span v-if="isBankProvided">{{ user.bank.name }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>

                                        <!-- Swift Code -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">Swift Code:</span>
                                            <div>
                                                <span v-if="isBankProvided">{{ user.bank.swift }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>

                                        <!-- IBAN -->
                                        <div class="flex flex-col  w-full">
                                            <span class="font-semibold">IBAN:</span>
                                            <div>
                                                <span v-if="isBankProvided">{{ user.bank.iban }}</span>
                                                <span v-else class="text-red-500 font-semibold"> Not Provided</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </Card>
                    </div>
                    

                </div>
            </AccordionContent>
        </AccordionPanel>
    </Accordion>
</template>

<script setup>
import { defineProps, ref } from 'vue';
import { useUserStatus } from '@/utils/userStatus'; 
// Define user as a prop
const props = defineProps({
  user: Object
});

const passedUser = ref(props.user);
const { isBankProvided, isAddressProvided,  isVatProvided, showAlert } = useUserStatus(passedUser);
</script>
<style scoped>
.p-accordionheader {
    padding: 0.9rem;
}
</style>